import { createRouter } from '@tanstack/react-router';
import { rootRoute } from './routes/__root';
import { indexRoute } from './routes/index';
import { loginRoute } from './routes/login';
import { twoFactorSetupRoute } from './routes/2fa.setup';
import { changePasswordRoute } from './routes/change-password';
import { forgotPasswordRoute } from './routes/forgot-password';
import { resetPasswordRoute } from './routes/reset-password';
import { notificationsRoute } from './routes/notifications';
import { myPayslipsRoute } from './routes/my-payslips';
import { analyticsEconomicsRoute } from './routes/analytics.economics';
import { companyProfileRoute } from './routes/company.profile';
import { vaultRoute } from './routes/vault';
import { crmClientsRoute } from './routes/crm.clients';
import { crmClientDetailRoute } from './routes/crm.clients.detail';
import { crmChannelsRoute } from './routes/crm.channels';
import { projectsRoute } from './routes/projects';
import { renewalsRoute } from './routes/renewals';
import { projectDetailRoute } from './routes/projects.detail';
import { myTasksRoute } from './routes/my-tasks';
import { allocationsRoute } from './routes/allocations';
import { costCentersRoute } from './routes/cost-centers';
import { ledgerAccountsRoute } from './routes/ledger.accounts';
import { ledgerCategoriesRoute } from './routes/ledger.categories';
import { ledgerTransactionsRoute } from './routes/ledger.transactions';
import { ledgerUnmappedRoute } from './routes/ledger.unmapped';
import { ledgerBankTemplatesRoute } from './routes/ledger.bank-templates';
import { ledgerStatementsRoute } from './routes/ledger.statements';
import { ledgerStatementDetailRoute } from './routes/ledger.statements.detail';
import { billingDocumentsRoute } from './routes/billing.documents';
import { billingDocumentDetailRoute } from './routes/billing.documents.detail';
import {
  billingDocumentEditRoute,
  billingDocumentNewRoute,
} from './routes/billing.documents.editor';
import { billingArAgingRoute } from './routes/billing.ar-aging';
import { billingGstr1Route } from './routes/billing.gstr1';
import { periodCloseRoute } from './routes/period-close';
import { periodCloseDetailRoute } from './routes/period-close.detail';
import { peopleLeaveRoute } from './routes/people.leave';
import { peopleHolidaysRoute } from './routes/people.holidays';
import { peopleKpiRoute } from './routes/people.kpi';
import { peopleAttendanceRoute } from './routes/people.attendance';
import { peopleRatesRoute } from './routes/people.rates';
import { statutoryConfigRoute } from './routes/statutory-config';
import { payrollRoute } from './routes/payroll';
import { payrollDetailRoute } from './routes/payroll.detail';
import { ideasRoute } from './routes/ideas';
import { ideaDetailRoute } from './routes/ideas.detail';
import { settingsNotificationsRoute } from './routes/settings.notifications';
import { settingsApiTokensRoute } from './routes/settings.api-tokens';
import { myQueueRoute } from './routes/my-queue';
import { analyticsRoute } from './routes/analytics';
import { salesProspectsRoute } from './routes/sales.prospects';
import { salesProspectDetailRoute } from './routes/sales.prospects.detail';
import { salesPipelineRoute } from './routes/sales.pipeline';
import { salesDashboardRoute } from './routes/sales.dashboard';
import { salesServicesRoute } from './routes/sales.services';
import { salesCsuiteMembersRoute } from './routes/sales.csuite-members';
import { peopleAccessRoute } from './routes/people-access';
import { workLogRoute } from './routes/work-log';
import { workLogClockOutRoute } from './routes/work-log.clock-out';
import { workLogHistoryRoute } from './routes/work-log.history';
import { absencesRoute } from './routes/people.absences';
import { allocationProposalRoute } from './routes/people.allocation-proposal';
import { chatConversationRoute, chatRoute } from './routes/chat';
import { profileRoute } from './routes/profile';

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  changePasswordRoute,
  forgotPasswordRoute,
  resetPasswordRoute,
  twoFactorSetupRoute,
  notificationsRoute,
  myPayslipsRoute,
  analyticsEconomicsRoute,
  companyProfileRoute,
  vaultRoute,
  crmClientsRoute,
  crmClientDetailRoute,
  crmChannelsRoute,
  projectsRoute,
  projectDetailRoute,
  renewalsRoute,
  myTasksRoute,
  allocationsRoute,
  costCentersRoute,
  ledgerAccountsRoute,
  ledgerCategoriesRoute,
  ledgerTransactionsRoute,
  ledgerUnmappedRoute,
  ledgerBankTemplatesRoute,
  ledgerStatementsRoute,
  ledgerStatementDetailRoute,
  billingDocumentsRoute,
  billingDocumentNewRoute,
  billingDocumentEditRoute,
  billingDocumentDetailRoute,
  billingArAgingRoute,
  billingGstr1Route,
  periodCloseRoute,
  periodCloseDetailRoute,
  peopleLeaveRoute,
  peopleHolidaysRoute,
  peopleKpiRoute,
  peopleAttendanceRoute,
  peopleRatesRoute,
  statutoryConfigRoute,
  payrollRoute,
  payrollDetailRoute,
  ideasRoute,
  ideaDetailRoute,
  settingsNotificationsRoute,
  settingsApiTokensRoute,
  myQueueRoute,
  analyticsRoute,
  salesProspectsRoute,
  salesProspectDetailRoute,
  salesPipelineRoute,
  salesDashboardRoute,
  salesServicesRoute,
  salesCsuiteMembersRoute,
  peopleAccessRoute,
  workLogRoute,
  workLogClockOutRoute,
  workLogHistoryRoute,
  absencesRoute,
  allocationProposalRoute,
  chatRoute,
  chatConversationRoute,
  profileRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
